import { FC, useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { ReportsCommand } from '../../../services/command';
import { SSRS } from '../ssrsPageManagement.classes';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    refresh?: any;
}
export const ReportDialog: FC<IProps> = ({ selectedRow, open = false, onClose, refresh }) => {
    const [reportTitle, setReportTitle] = useState(selectedRow ? selectedRow?.reportTitle : '');

    const [reportUri, setReportUri] = useState(selectedRow ? selectedRow?.reportUri : '');
    useEffect(() => {
        setReportTitle(selectedRow?.reportTitle === '-' ? ' ' : selectedRow?.reportTitle);
        setReportUri(selectedRow?.reportUri === '-' ? ' ' : selectedRow?.reportUri);
    }, [selectedRow]);

    const handleChangeReportUri = (event: any) => {
        setReportUri(event.target.value);
    };
    const handleChangeReportTitle = (event: any) => {
        setReportTitle(event.target.value);
    };

    const { t } = useTranslation();

    const UpdateMobilHandler = async () => {
        let params = {
            reportId: selectedRow.reportId,
            ReportTitle: reportTitle,
            ReportUri: reportUri,
        };

        if (reportUri && reportUri?.trim().length > 0 && reportTitle && reportTitle?.trim().length > 0) {
            ReportsCommand.UpdateReportsListItem(params)
                .then(() => {
                    Swal.fire(t('general.updated'), ' ', 'success');
                    refresh();
                    onClose();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const CreateMobilHandler = async () => {
        let params = {
            ReportTitle: reportTitle,
            ReportUri: reportUri,
        };
        let myArray = [];
        myArray.push(params);
        if (reportUri && reportUri?.trim().length > 0 && reportTitle && reportTitle?.trim().length > 0) {
            ReportsCommand.CreateReports(myArray)
                .then(() => {
                    Swal.fire(t('general.added'), ' ', 'success');
                    refresh();
                    onClose();
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };

    const submitHandler = (event: any) => {
        event.preventDefault();
        CreateMobilHandler();
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={SSRS.reportDialog}
            data-report-id={selectedRow?.reportId}
        >
            <DialogTitle className={SSRS.reportDialogTitle}>{'Rapor'}</DialogTitle>
            <form onSubmit={submitHandler} className={SSRS.reportDialogForm}>
                <DialogContent className={SSRS.reportDialogContent}>
                    <TextField
                        className={SSRS.inputReportTitle}
                        label="Report Title"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.reportTitle}
                        onChange={handleChangeReportTitle}
                    />
                    <TextField
                        className={SSRS.inputReportUri}
                        label="Report Url"
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        variant="standard"
                        defaultValue={selectedRow?.reportUri}
                        onChange={handleChangeReportUri}
                    />
                </DialogContent>
                <DialogActions className={SSRS.reportDialogActions}>
                    {selectedRow?.reportId ? (
                        <Button
                            onClick={UpdateMobilHandler}
                            className={SSRS.btnReportUpdate}
                            data-report-id={selectedRow?.reportId}
                        >
                            {t('general.update')}
                        </Button>
                    ) : (
                        <Button type="submit" className={SSRS.btnReportSave}>
                            {t('general.save')}{' '}
                        </Button>
                    )}
                    <Button onClick={onClose} className={SSRS.btnReportCancel}>
                        {t('general.cancel')}{' '}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
